if (!customElements.get('bg-cart-upsells')) {
  customElements.define(
    'bg-cart-upsells',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', this.handleSubmit);

        if (this.dataset.checkAkhi === 'true') {
          this.updateFastShipForAkhi();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('submit', this.handleSubmit);
      }

      handleSubmit = async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('.cart-drawer__upsell-form')) return;

        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const error = form.querySelector('.cart-drawer__upsell-error');
        const variantInput = form.elements.namedItem('id');
        if (!(button instanceof HTMLButtonElement) || !(variantInput instanceof HTMLInputElement)) return;

        const originalLabel = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
        if (error instanceof HTMLElement) error.hidden = true;

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{ id: Number(variantInput.value), quantity: 1 }],
              sections: [this.dataset.sectionId],
              sections_url: window.location.pathname,
            }),
          });
          const addResponse = await response.json();
          if (!response.ok) throw new Error(addResponse.description || addResponse.message || 'Unable to add item.');

          const root = window.Shopify?.routes?.root || '/';
          const cartResponse = await fetch(`${root}cart.js`);
          const cart = await cartResponse.json();

          this.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'bg-cart-upsells',
                data: {
                  source: 'bg-cart-upsells',
                  itemCount: cart.item_count,
                  sections: addResponse.sections,
                },
              },
            })
          );
        } catch (requestError) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalLabel;
          if (error instanceof HTMLElement) {
            error.textContent = requestError instanceof Error ? requestError.message : 'Unable to add item.';
            error.hidden = false;
          }
        }
      };

      async updateFastShipForAkhi() {
        const variants = {
          1: { id: 44979770425398, price: 50 },
          2: { id: 44979770458166, price: 70 },
          3: { id: 44979770490934, price: 90 },
        };

        try {
          const response = await fetch('https://get.geojs.io/v1/ip/geo.json');
          const location = await response.json();
          if (location.country_code !== 'US' || !['Alaska', 'Hawaii'].includes(location.region)) return;

          const selection = variants[Number(this.dataset.cartTier)];
          const input = this.querySelector('[data-fast-ship-variant]');
          const button = this.querySelector('[data-fast-ship-button]');
          if (input instanceof HTMLInputElement) input.value = selection.id;
          if (button instanceof HTMLButtonElement) button.textContent = `Add Fast Ship — $${selection.price}.00`;
        } catch (_) {
          // Lower 48 is the safe fallback when GeoIP is unavailable.
        }
      }
    }
  );
}
